import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    chevron: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 24,
        marginRight: theme.spacing(0.5),
        color: theme.palette.text.secondary,
    },
    itemContent: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        gap: theme.spacing(0.5),
    },
    listItemButton: {
        "&:hover": {
            backgroundColor: theme.palette.action.hover,
        },
    },
    listItemText: {
        margin: 0,
    },
    deviceCount: {
        marginLeft: theme.spacing(1),
        color: theme.palette.text.secondary,
    },
    highlightedDevice: {
        backgroundColor: theme.palette.action.selected,
    },
    deviceName: {
        fontWeight: 500,
    },
    deviceSerial: {
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing(1),
    },
    // Rows are virtualized at a fixed height, so the reason stays on the device's line.
    incompatibility: {
        marginLeft: theme.spacing(2),
        color: theme.palette.text.secondary,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    rowHeight: {
        height: 48,
    },
}));
